import React from "react";
import "./customButton.scss";
import classNames from "classnames";

const ScheduleDemoButton = (props) => {
  const borderColorClass = `border-${props.borderColor || "black"}`;
  const textColorClass = `text-${props.textColor || "black"}`;
  const backgroundColorClass = `bg-${props.bgColor || "black"}`;
  const hoverColor = props.hoverColor || "black";
  const hoverTextColor = hoverColor === "white" ? "black" : "white";
  return (
    <div className="buttons">
      <button
        className={classNames(
          "up poppins_bold rounded-md border max-[480px]:m-0 max-[480px]:p-3",
          borderColorClass,
          textColorClass,
          backgroundColorClass
        )}
        style={{
          "--hover-color": hoverColor,
          "--hover-text-color": hoverTextColor,
        }}
      >
        {props.children}
      </button>
    </div>
  );
};

export default ScheduleDemoButton;
